/**
 * Theme Toggle Component
 * A button to switch between light and dark theme
 */

import { Moon, Sun } from 'lucide-react'
import { useTheme } from '@/lib/theme-provider'

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()

  const toggleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark')
  }

  return (
    <button
      onClick={toggleTheme}
      className="flex min-h-11 items-center gap-2 rounded-full border border-[var(--color-border)] bg-[var(--color-bg-secondary)] px-3.5 py-2 transition-all duration-300 ease-brisk hover:border-primary/40 hover:bg-[var(--color-control-surface-hover)] active:scale-[0.97] group"
      aria-label="Toggle theme"
      title={`Current theme: ${theme === 'dark' ? 'Dark' : 'Light'}`}
    >
      {theme === 'dark' ? (
        <Moon className="h-4 w-4 text-[var(--color-text-secondary)] group-hover:text-primary transition-colors" />
      ) : (
        <Sun className="h-4 w-4 text-[var(--color-text-secondary)] group-hover:text-primary transition-colors" />
      )}
      <span className="text-xs font-medium text-[var(--color-text-secondary)] group-hover:text-[var(--color-text-primary)] transition-colors hidden sm:inline">
        {theme === 'dark' ? 'Dark' : 'Light'}
      </span>
    </button>
  )
}

/**
 * Compact Theme Toggle (Icon Only)
 * For headers or tight spaces
 */
export function ThemeToggleCompact() {
  const { theme, setTheme } = useTheme()

  const toggleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark')
  }

  return (
    <button
      onClick={toggleTheme}
      className="flex size-11 items-center justify-center rounded-full border border-[var(--color-border)] bg-transparent text-[var(--color-text-secondary)] transition-[background-color,border-color,color,transform] duration-300 ease-brisk hover:border-[var(--color-border-strong)] hover:bg-[var(--color-control-surface-hover)] hover:text-[var(--color-text-primary)] focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-primary/50 active:scale-[0.97]"
      aria-label="Toggle theme"
    >
      {theme === 'dark' ? (
        <Moon className="h-4 w-4 transition-colors" />
      ) : (
        <Sun className="h-4 w-4 transition-colors" />
      )}
    </button>
  )
}
